import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';
import { classNames, LoadingIcon, Tooltip, FaIcon } from '@panwds/react-ui';

var buttonClasses = "tw-box-border tw-border-0 tw-bg-transparent tw-group focus:tw-outline-none tw-flex tw-items-center tw-space-x-2";
var AddButton = forwardRef(function (_a, ref) {
    var disabled = _a.disabled, isLoading = _a.isLoading, _b = _a.showLabel, showLabel = _b === void 0 ? false : _b, isOpen = _a.isOpen, rest = __rest(_a, ["disabled", "isLoading", "showLabel", "isOpen"]);
    var intl = useIntl();
    var iconClasses = classNames("tw-inline-flex tw-items-center tw-justify-center tw-text-dark-bg", "tw-rounded-full tw-w-8 tw-h-8 focus:tw-outline-none", isOpen && "tw-ring", disabled
        ? "tw-bg-gray-400 tw-cursor-not-allowed"
        : "tw-bg-blue-600 tw-cursor-pointer hover:tw-bg-blue-700 active:tw-bg-blue-800 group-focus:tw-ring dark:tw-bg-blue-300 dark:hover:tw-bg-blue-700 dark:active:tw-bg-blue-600");
    var textClasses = classNames(isLoading
        ? "tw-text-default dark:tw-text-dark-bg"
        : disabled
            ? "tw-text-disabled dark:tw-text-dark-bg-disabled"
            : "tw-text-link dark:tw-text-dark-bg-link");
    var label = disabled
        ? intl.formatMessage({ id: "+0hcL4", defaultMessage: [{ type: 0, value: "Filters are disabled" }] })
        : intl.formatMessage({ id: "GVFFft", defaultMessage: [{ type: 0, value: "Add Filter" }] });
    var AddIcon = function () { return (React.createElement("div", { className: iconClasses },
        React.createElement(FaIcon, { faIconDef: faFilter }))); };
    if (showLabel || isLoading) {
        return (React.createElement("button", __assign({ className: buttonClasses, ref: ref }, rest, { type: "button", disabled: disabled }),
            React.createElement(AddIcon, null),
            React.createElement("span", { className: textClasses }, isLoading ? (React.createElement(React.Fragment, null,
                React.createElement(LoadingIcon, { size: "lg", addClassName: "tw-mr-2", "aria-label": "" }),
                intl.formatMessage({ id: "VHbZhY", defaultMessage: [{ type: 0, value: "Loading" }] }))) : (label))));
    }
    return (React.createElement("span", __assign({ ref: ref }, rest),
        React.createElement(Tooltip, { label: label },
            React.createElement("button", { "aria-label": label, className: buttonClasses, disabled: disabled, "data-testid": "add-filter", type: "button" },
                React.createElement(AddIcon, null)))));
});
AddButton.displayName = "AddButton";

export { AddButton };
//# sourceMappingURL=AddButton.esm.js.map
